"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var warn = function (s) {
    console.warn('[react-gtm]', s);
};
exports.default = warn;
//# sourceMappingURL=warn.js.map